export default __webpack_public_path__ + "static/media/3 - Экотропы в городе.630d9e12.jpg";